import { ViewEncapsulation } from '@angular/compiler/src/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportYear } from '../../../models/report.model';
import { LookupService } from '../../../services/lookups/lookup.service';
import { ReportsCountByStatusCardComponent } from './reports-count-by-status-card/reports-count-by-status-card.component';
import { ReportsTotalCountCardComponent } from './reports-total-count-card/reports-total-count-card.component';
import { ReportCountsFiveYearCardComponent } from './report-counts-five-year-card/report-counts-five-year-card.component';
import { ReportCountByTypeCardComponent } from './report-count-by-type-card/report-count-by-type-card.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  ReportYears: ReportYear[];
  @ViewChild(ReportsTotalCountCardComponent) reportTotalCntComponent: ReportsTotalCountCardComponent;
  @ViewChild(ReportCountsFiveYearCardComponent) reportCountsFiveYearCardComponent: ReportCountsFiveYearCardComponent;
  @ViewChild(ReportsCountByStatusCardComponent) reportByStatusCntComponent:ReportsCountByStatusCardComponent;
  @ViewChild(ReportCountByTypeCardComponent) reportByTypeCntComponent:ReportCountByTypeCardComponent;
  constructor(private lookupService:LookupService) { }
  currentYear: number;
  selectedYear :ReportYear;
  ngOnInit() {  
  }

  ngAfterViewInit (){
    this.LoadReportYears();
  }


   LoadReportYears()
   {
    this.currentYear = new Date().getFullYear();

    this.lookupService.getReportYear().subscribe((data: ReportYear[]) => {
      this.ReportYears =data;
      for (let cnt = data.length - 1; cnt >= 0; cnt--) {
        if (this.ReportYears[cnt].year > this.currentYear ) {
          this.ReportYears.splice(cnt, 1);
        }
      }
      this.ReportYears.sort((a,b):number=>{
        if (a.year > b.year) return -1;
        if (a.year < b.year) return 1;
        return 0;
      })

      this.reportCountsFiveYearCardComponent.loadChart(this.ReportYears[0].id,this.ReportYears[0].year);
      this.reportTotalCntComponent.loadProgressChart(this.ReportYears[0].id,this.ReportYears[0].year);
      this.reportByTypeCntComponent.loadChart(this.ReportYears[0].id);
      this.reportByStatusCntComponent.loadReportsCountsByStatusChart(this.ReportYears[0].id,this.ReportYears[0].year);
      
      
    });
   }
   onReportYearChange(reportYear:ReportYear)
   {
    
    this.reportCountsFiveYearCardComponent.loadChart(reportYear.id,reportYear.year);
    this.reportTotalCntComponent.loadProgressChart(reportYear.id,reportYear.year);
    this.reportByTypeCntComponent.loadChart(reportYear.id);
    this.reportByStatusCntComponent.loadReportsCountsByStatusChart(reportYear.id,reportYear.year);
    
   }
}
